var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEyeBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.77 5.26797C15.65 5.06797 12.664 0.667969 7.99827 0.667969C3.33257 0.667969 0.346522 5.06797 0.226546 5.26797C-0.0667264 5.7213 -0.0667264 6.29463 0.226546 6.74797C0.346522 6.93463 3.3459 11.3346 7.99827 11.3346C12.6506 11.3346 15.65 6.93463 15.77 6.73463C16.0766 6.29463 16.0766 5.70797 15.77 5.26797ZM7.99827 9.33463C6.15865 9.33463 4.66563 7.8413 4.66563 6.0013C4.66563 4.1613 6.15865 2.66797 7.99827 2.66797C9.83789 2.66797 11.3309 4.1613 11.3309 6.0013C11.3309 7.8413 9.83789 9.33463 7.99827 9.33463Z",
    fill: "#4F4FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9983 8.00137C9.10264 8.00137 9.99789 7.10594 9.99789 6.00137C9.99789 4.8968 9.10264 4.00137 7.9983 4.00137C6.89396 4.00137 5.99871 4.8968 5.99871 6.00137C5.99871 7.10594 6.89396 8.00137 7.9983 8.00137Z",
    fill: "#4F4FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeBlue);
export default __webpack_public_path__ + "static/media/ic_eye_blue.7eb26d2e0138bb6327c3eb8a147064a0.svg";
export { ForwardRef as ReactComponent };